/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ExportParamsVO } from '../model';
// @ts-ignore
import * as Objs from './index'
// @ts-ignore
import { DataResponseVO, DataRequestVO, ExportRequestVO } from '@mc/data-filter-react';

/**
 * PublicExportControllerApi - axios parameter creator
 * @export
 */
export const PublicExportControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Stažení dočasného souboru
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadTemporaryFile: async (key: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('downloadTemporaryFile', 'key', key)
            const localVarPath = `/api/public-export/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export vrstev/objektů do Excelu
         * @param {ExportParamsVO} exportParamsVO Parametry exportu
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportToExcel: async (exportParamsVO: ExportParamsVO, context?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportParamsVO' is not null or undefined
            assertParamExists('exportToExcel', 'exportParamsVO', exportParamsVO)
            const localVarPath = `/api/public-export/excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportParamsVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicExportControllerApi - functional programming interface
 * @export
 */
export const PublicExportControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicExportControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Stažení dočasného souboru
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadTemporaryFile(key: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadTemporaryFile(key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Export vrstev/objektů do Excelu
         * @param {ExportParamsVO} exportParamsVO Parametry exportu
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportToExcel(exportParamsVO: ExportParamsVO, context?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.exportToExcel(exportParamsVO, context, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PublicExportControllerApi - factory interface
 * @export
 */
export const PublicExportControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicExportControllerApiFp(configuration)
    return {
        /**
         * Stažení dočasného souboru
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadTemporaryFile(key: string, options?: any): AxiosPromise<void> {
            return localVarFp.downloadTemporaryFile(key, options).then((request) => request(axios, basePath));
        },
        /**
         * Export vrstev/objektů do Excelu
         * @param {ExportParamsVO} exportParamsVO Parametry exportu
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportToExcel(exportParamsVO: ExportParamsVO, context?: string, options?: any): AxiosPromise<string> {
            return localVarFp.exportToExcel(exportParamsVO, context, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PublicExportControllerApi - interface
 * @export
 * @interface PublicExportControllerApi
 */
export interface PublicExportControllerApiInterface {
    /**
     * Stažení dočasného souboru
     * @param {string} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicExportControllerApiInterface
     */
    downloadTemporaryFile(key: string, options?: any): AxiosPromise<void>;

    /**
     * Export vrstev/objektů do Excelu
     * @param {ExportParamsVO} exportParamsVO Parametry exportu
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicExportControllerApiInterface
     */
    exportToExcel(exportParamsVO: ExportParamsVO, context?: string, options?: any): AxiosPromise<string>;

}

/**
 * PublicExportControllerApi - object-oriented interface
 * @export
 * @class PublicExportControllerApi
 * @extends {BaseAPI}
 */
export class PublicExportControllerApi extends BaseAPI implements PublicExportControllerApiInterface {
    /**
     * Stažení dočasného souboru
     * @param {string} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicExportControllerApi
     */
    public downloadTemporaryFile(key: string, options?: any) {
        return PublicExportControllerApiFp(this.configuration).downloadTemporaryFile(key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Export vrstev/objektů do Excelu
     * @param {ExportParamsVO} exportParamsVO Parametry exportu
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicExportControllerApi
     */
    public exportToExcel(exportParamsVO: ExportParamsVO, context?: string, options?: any) {
        return PublicExportControllerApiFp(this.configuration).exportToExcel(exportParamsVO, context, options).then((request) => request(this.axios, this.basePath));
    }
}
